<template>

      <!-- Notification bar & Close css - .navbar --> 
      <div v-if="eventNotification" class="notification-bar-event">
      <h1> 
      <!-- <a href="https://explorer.gitcoin.co/#/round/424/0x98720dd1925d34a2453ebc1f91c9d48e7e89ec29/0x98720dd1925d34a2453ebc1f91c9d48e7e89ec29-238" target="_blank">
        Gitcoin Grant #GG19 : November 15-29, 2023 Thank you everyone For Support and Donates 🙏
      </a>
      <br> -->
      <i class="small-text">
       <b>Note</b>: The demo is in testing and may have bugs, but Smart Contracts work well, are accurate, are secure and <a href="https://wizard-bridge-evm.gitbook.io/docs/use-cases/for-developers" target="_blank">(Open-source)</a> / We are testing bug detection and improvements before it goes to Mainnet (please notice)</i>
      </h1>
      &nbsp; <button class="delete" @click="closeNotification"></button>
      </div>

  <nav
    class="navbar"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <!-- <img
        src="img/logo.png"
        width="50"
      > -->
      <img
        src="img/logo.png"
        width="60" height="60"
      >
      
      <a
        role="button"
        aria-label="menu"
        aria-expanded="false"
        data-target="navbarBasicExample"
        :class="showNav ? 'is-active navbar-burger' : 'navbar-burger'"
        @click.prevent="showNav = !showNav"
      >
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </a>
    </div>




    <div
      id="navbarBasicExample"
      :class="showNav ? 'is-active navbar-menu' : 'navbar-menu'"
    >
      <div
        v-if="connected"
        class="navbar-start"
      >
<div class="tabs is-boxed">
  <ul>
    <li :class="{ 'is-active': activeTab === 'bridge' }">
      <router-link :to="{ name: 'bridge' }">
        <span class="icon is-small"><i class="fas fa-star" aria-hidden="true"></i></span>
        <span>Bridge</span>
      </router-link>
    </li>
    <li :class="{ 'is-active': activeTab === 'import' }">
      <router-link :to="{ name: 'import' }">
        <span class="icon is-small"><i class="fas fa-download" aria-hidden="true"></i></span>
        <span>Import</span>
      </router-link>
    </li>
    <li :class="{ 'is-active': activeTab === 'interface' }">
      <router-link :to="{ name: 'interface' }">
        <span class="icon is-small"><i class="fas fa-list" aria-hidden="true"></i></span>
        <span>Interface</span>
      </router-link>
    </li>
    <li :class="{ 'is-active': activeTab === 'history' }">
      <router-link :to="{ name: 'history' }">
        <span class="icon is-small"><i class="far fa-file-alt" aria-hidden="true"></i></span>
        <span>History</span>
      </router-link>
    </li>
  </ul>
</div>
      </div>




      <div class="navbar-end">
        <div class="navbar-item">
          <img
            class="blockie"
            :src="blockie"
            :alt="address"
          >
          <div v-if="connected">
            <span class="tag is-info is-light is-medium   is-rounded"><i class="fas fa-user" aria-hidden="true">&nbsp;</i>{{ ellipseAddress(account) }}</span>
            <!-- <span class="tag is-info is-light is-medium">{{ ellipseAddress(account).slice(0, 5) }}...{{ ellipseAddress(account).slice(-3) }}</span> -->
            <span class="tag is-info is-light is-medium   is-rounded "><i class="fas fa-layer-group" aria-hidden="true">&nbsp;</i>{{ chainData.name }}</span>
            <!-- Button discinnect -->
            <input
              class="button is-primary is-small   is-danger is-rounded is-outlined"
              type="button"
              value="Disconnect"
              @click.prevent="$emit('disconnect')"
            >
          </div>
          <!-- Button connect -->
          <input
            v-else
            class="button is-primary   is-rounded"
            type="button"
            value="Connect Wallet"
            @click.prevent="$emit('connect')"
          >

        </div>
      </div>


      
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
import blockies from 'blockies'
import utilities from '@/mixins/utilities'
import { getChainData } from '@/constants/chains'

export default {
  mixins: [utilities],
  emits: [
    'connect',
    'disconnect'
  ],
  data () {
    return {
      chainData: {},
      blockie: '',
      showNav: false,
      eventNotification: true,
    }
  },
  computed: mapState([
    'connected',
    'account',
    'chainId'
  ]),
  watch: {
    account () {
      const seed = this.$store.state.account.toLowerCase() || ''
      this.blockie = blockies({ seed }).toDataURL('image/png')
    },
    chainId () {
      this.chainData = this.chainId ? getChainData(this.chainId) : null
    }
  },
  methods: {
    closeNotification() {
      this.eventNotification = false
      // Move the navbar to the top when closing the notification
      this.$nextTick(() => {
        document.querySelector('.navbar').style.marginTop = '0'
      })
    },
  },
}
</script>

<style scoped>
.tag {
  margin-right: 5px;
}

.blockie {
  margin-right: 5px;
  border-radius: 4px;
}



/* Notification bar styles */
.notification-bar-event {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #2196f3; /* You can adjust the background color */
  color: #fff; /* You can adjust the text color */
  padding: 6px; /* Increase the padding to make it larger */
  text-align: center;
  z-index: 999;
  display: flex;
  justify-content: center;
}

.notification-bar-event h1 {
  margin: 0;
  font-size: 18px; /* Increase the font size if needed */
  display: center;
}

.notification-bar-event h1 a {
  color: white; /* สีของลิงก์ในสภาพปกติ */
  text-decoration: none; /* ไม่มีการเส้นใต้ลิงก์ */
  transition: color 0.3s; /* เพิ่ม transition เพื่อให้สีเปลี่ยนได้เรียบขึ้น */
}

.notification-bar-event h1 a:hover {
  color: #000000; /* สีของลิงก์เมื่อถูกชี้เลือก */
}

.notification-bar-event button.delete {
  background: none;
  border: none;
  color: #fff;
  font: inherit;
  cursor: pointer;
  padding: 0;
  margin: 0;
  font-size: 24px; /* Increase the font size if needed */
}

/* Add margin to the navbar to push it down */
.navbar {
  margin-top: 110px; /* Adjust the margin to create space below the notification bar */
  transition: margin-top 0.5s; /* Add transition effect for smoother animation */
}


/* */

i.small-text {
  font-size: 10px;
}







/* Media queries for responsiveness */
@media (max-width: 768px) {
  .notification-bar-event h1 {
    font-size: 16px; /* Adjust font size for smaller screens */
  }
}

@media (max-width: 576px) {
  .notification-bar-event h1 {
    font-size: 14px; /* Further adjust font size for even smaller screens */
  }
}


</style>
